export const NABLA_RECOMMENDED_RECORDING_SAMPLE_RATE_HZ = 16000;
export const SCRIBE_RECORDER_TIMESLICE_MS = 100;
export const IS_CHROME_EXTENSION =
  window.location.protocol === "chrome-extension:";
